import moment from 'moment';
import { CHRONOLOGICAL_DATE_TIME_FORMAT } from './constants';

export function checkUrlTroubleshootingDatesValidity(state) {
   const newState = { ...state };
   const MIN_START_DATE_UTC = moment.utc().startOf('day').subtract(31, 'days');
   const { troubleTimespan, troubleSelectedPlayout, troubleSelectedPublish, troubleSelectedAlert } = state;
   const { start, end } = troubleTimespan; // moments
   const { publishFineEnd } = troubleSelectedPublish; // strings
   const { playoutFineEnd } = troubleSelectedPlayout;
   const { alertFineEnd } = troubleSelectedAlert;

   const isStartValid = start.isSameOrAfter(MIN_START_DATE_UTC);
   const isEndValid = end.isSameOrAfter(MIN_START_DATE_UTC);

   const playoutFineEndUnix =
      playoutFineEnd !== ''
         ? moment.utc(playoutFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isValid()
            ? moment.utc(playoutFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).unix()
            : 0
         : 0;
   const publishFineEndUnix =
      publishFineEnd !== ''
         ? moment.utc(publishFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isValid()
            ? moment.utc(publishFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).unix()
            : 0
         : 0;
   const alertFineEndUnix =
      alertFineEnd !== ''
         ? moment.utc(alertFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isValid()
            ? moment.utc(alertFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).unix()
            : 0
         : 0;

   const fineEndValues = [playoutFineEndUnix, publishFineEndUnix, alertFineEndUnix];
   const fineEndLables = ['playout', 'publish', 'alert'];
   const newEndUnix = Math.max(...fineEndValues);
   const newEndLabel = fineEndLables[fineEndValues.indexOf(newEndUnix)];

   const isPlayoutFineEndValid =
      playoutFineEnd !== ''
         ? moment.utc(playoutFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isSameOrAfter(MIN_START_DATE_UTC)
         : false;

   const isPublishFineEndValid =
      publishFineEnd !== ''
         ? moment.utc(publishFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isSameOrAfter(MIN_START_DATE_UTC)
         : false;

   const isAlertFineEndValid =
      alertFineEnd !== ''
         ? moment.utc(alertFineEnd, CHRONOLOGICAL_DATE_TIME_FORMAT).isSameOrAfter(MIN_START_DATE_UTC)
         : false;

   if (!isStartValid) {
      newState.troubleTimespan.start = MIN_START_DATE_UTC.clone();
      newState.troubleshootingTimespanValidationAlarm.message =
         '"From" date has been adjusted to match the valid time range!';
      if (isEndValid) {
         // Do nothing if End is valid
      } else if (isPublishFineEndValid || isAlertFineEndValid || isPlayoutFineEndValid) {
         newState.troubleTimespan.end = moment.unix(newEndUnix).utc();
         newState.troubleshootingTimespanValidationAlarm.message = `"From" & "To" dates have been adjusted to match the valid time range! "To" was set to the pre-selected ${newEndLabel}'s end date.`;
      } else {
         newState.troubleTimespan.end = moment.utc();
         newState.troubleshootingTimespanValidationAlarm.message =
            '"From" & "To" dates have been adjusted to match the valid time range!';
      }
   }

   return newState;
}
